module.exports = __webpack_public_path__ + "img/tabActive.fc40695b.png";